import { render, staticRenderFns } from "./painel-card-vivo.vue?vue&type=template&id=551bec34&scoped=true&"
import script from "./painel-card-vivo.vue?vue&type=script&lang=js&"
export * from "./painel-card-vivo.vue?vue&type=script&lang=js&"
import style0 from "./painel-card-vivo.vue?vue&type=style&index=0&id=551bec34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551bec34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551bec34')) {
      api.createRecord('551bec34', component.options)
    } else {
      api.reload('551bec34', component.options)
    }
    module.hot.accept("./painel-card-vivo.vue?vue&type=template&id=551bec34&scoped=true&", function () {
      api.rerender('551bec34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-card-vivo/painel-card-vivo.vue"
export default component.exports